import { DsBadgeTheme } from '@design-system/ds-badge/types/ds-badge-theme.type';
import { FileAttachmentTagStatuses } from '@enums/file-attachment-tag.enum';

/** Dialog width for the View Files modal, the files table needs a wide dialog. */
export const VIEW_FILES_MODAL_WIDTH = '70em';

/**
 * Page size of the files request. The endpoint only supports `page`/`pageSize`, so the modal takes the
 * whole list at once and does the searching, filtering, sorting and paging on the client.
 */
export const VIEW_FILES_FETCH_PAGE_SIZE = 500;

/** Number of files rendered by one page of the files table. */
export const VIEW_FILES_PAGE_SIZE = 10;

/** Id of the `All` option of the file type filter — a sentinel that no real file extension can collide with. */
export const ALL_FILE_TYPES_ID = '__all__';

/** Design system badge theme per file attachment tag. */
export const FILE_TAG_BADGE_THEME: Record<string, DsBadgeTheme> = {
  [FileAttachmentTagStatuses.flightRequestForm]: 'blue',
  [FileAttachmentTagStatuses.aviationSpecialistApproval]: 'indigo',
  [FileAttachmentTagStatuses.airCharterQuote]: 'purple',
  [FileAttachmentTagStatuses.airCharterItinerary]: 'blue-light',
  [FileAttachmentTagStatuses.organSpecimenPhoto]: 'pink',
  [FileAttachmentTagStatuses.flightCostCalculator]: 'orange',
  [FileAttachmentTagStatuses.cateringReceipt]: 'success',
};

/** Fallback badge theme for tags without a dedicated color. */
export const FILE_TAG_BADGE_DEFAULT_THEME: DsBadgeTheme = 'gray';

/** Entity the file was uploaded from — service request level. */
export const FILE_UPLOADED_FROM_SERVICE_REQUEST = 'Itinary';

/** Entity the file was uploaded from — leg (service request step) level. */
export const FILE_UPLOADED_FROM_LEG = 'ServiceRequestStep';
